<template>
  <va-page-layout
    @toggleSidebar="toggleSidebar"
    :mobileWidth="mobileWidth"
  >
    <app-navbar
      :minimized.sync="minimized"
    />
    <app-sidebar
      :minimized="minimized"
    />
    <main
      slot="content"
      id="content"
      class="layout gutter--xl reset-padding--bottom fluid"
      :class="{'app-layout__main--full-width-sidebar': !minimized}"
      role="main">
      <router-view :key="$route.fullPath"></router-view>
    </main>
    <va-modal show.sync="true" ref="modalVersao" :okText="$t('modal.close')" :okClass="'btn btn-primary btn-sm'"
      size="large" v-model="mostrarModalVersao" :title="'Sobre o SP360'" :cancelText="''"  class="modalVersao"
      @ok="fecharModal()" @cancel="fecharModal()">
      <template slot="default">
        <div class="row">
            Versão do Frontend: v{{ this.versaoFrontend }}<br>
        </div>
      </template>
    </va-modal>
    <span slot="footer">
        {{ new Date().getFullYear() }}.  <a href="https://www.prefeitura.sp.gov.br/cidade/secretarias/inovacao/" target="_blank" style="color:#34495e;text-decoration: underline;">Secretaria Municipal de Inovação e Tecnologia</a> da <a href="http://www.capital.sp.gov.br/" target="_blank" style="color:#34495e;text-decoration: underline;">Cidade de São Paulo</a>.
    </span>
  </va-page-layout>
</template>

<script>
import VaPageLayout from './VaPageLayout'
import AppNavbar from './app-navbar/AppNavbar'
import AppSidebar from './app-sidebar/AppSidebar'
import ConstantesGlobais from '@/utils/ConstantesGlobais'
import { mapGetters } from 'vuex'
import AppTopbar from './app-topbar/AppTopbar'

export default {
  name: 'app-layout',
  components: {
    AppTopbar,
    VaPageLayout,
    AppNavbar,
    AppSidebar,
  },
  data () {
    return {
      minimized: false,
      mobileWidth: 767,
      mostrarModalVersao: false,
      versaoFrontend: ConstantesGlobais.VERSAO_FRONTEND
    }
  },
  watch: {
    '$store.state.app.mostrarVersao': function() {
      this.mostrarModalVersao = this.$store.state.app.mostrarVersao
    }
  },
  computed: {
    ...mapGetters([
      'isLoading',
    ]),
  },
  methods: {
    toggleSidebar (minimized) {
      this.minimized = minimized
    },
    fecharModal() {
      this.$store.commit('setMostrarVersao', false)
    }
  },
}
</script>

<style lang="scss">
  .reset-padding--bottom {
    padding-bottom: 0.5rem !important;
  }
  .app-layout {
    &__main {
      &--full-width-sidebar {
        @include media-breakpoint-down(xs) {
          display: none;
        }
      }
    }
  }
  .footer-text {
    text-align: center;
  }
</style>
